import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const fileUrl = (path) => (!path ? '' : (path.startsWith('/api/') ? `${BASE}${path}` : path));

const TOKEN_KEY = 'dogm_admin_token';
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  // Auth
  login: (passcode) => client.post('/auth/login', { passcode }).then(r => r.data),
  verify: () => client.get('/auth/verify').then(r => r.data),

  // Teachings
  listTeachings: () => client.get('/teachings').then(r => r.data),
  createTeaching: (formData, onProgress) => client.post('/teachings', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then(r => r.data),
  deleteTeaching: (id) => client.delete(`/teachings/${id}`).then(r => r.data),

  // Dosages
  listDosages: () => client.get('/dosages').then(r => r.data),
  createDosage: (formData, onProgress) => client.post('/dosages', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then(r => r.data),
  deleteDosage: (id) => client.delete(`/dosages/${id}`).then(r => r.data),
  updateDosage: (id, formData, onProgress) => client.patch(`/dosages/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then(r => r.data),

  // Materials
  listMaterials: () => client.get('/materials').then(r => r.data),
  createMaterial: (formData, onProgress) => client.post('/materials', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  }).then(r => r.data),
  deleteMaterial: (id) => client.delete(`/materials/${id}`).then(r => r.data),

  // Prayer wall
  listPrayers: () => client.get('/prayer-requests').then(r => r.data),
  createPrayer: (body) => client.post('/prayer-requests', body).then(r => r.data),
  prayFor: (id) => client.post(`/prayer-requests/${id}/pray`).then(r => r.data),

  // Newsletter / contact
  subscribe: (email) => client.post('/newsletter', { email }).then(r => r.data),
  contact: (body) => client.post('/contact', body).then(r => r.data),

  // Vigil RSVPs
  rsvpVigil: (body) => client.post('/vigil-rsvps', body).then(r => r.data),
  vigilRsvpCount: (vigilDate) => client.get('/vigil-rsvps/count', { params: { vigil_date: vigilDate } }).then(r => r.data),
  adminVigilRsvps: (vigilDate) => client.get('/admin/vigil-rsvps', { params: vigilDate ? { vigil_date: vigilDate } : {} }).then(r => r.data),

  // Admin inbox
  adminPrayers: () => client.get('/admin/prayer-requests').then(r => r.data),
  adminMessages: () => client.get('/admin/messages').then(r => r.data),
  adminInboxSummary: () => client.get('/admin/inbox-summary').then(r => r.data),
  markPrayerRead: (id) => client.post(`/admin/prayer-requests/${id}/read`).then(r => r.data),
  markMessageRead: (id) => client.post(`/admin/messages/${id}/read`).then(r => r.data),
};

export default api;
